import context from '../context';
import authenticationService from '../service/authentication';
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { frontUrl } from 'frilans-finans/variables';

export default class LogoutLink extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    classes: PropTypes.string
  };

  onClick () {
    authenticationService.logout();
    window.location = frontUrl;
  }

  render () {
    let classes = this.props.classes;

    return (
      <Link className={classes} to={context.routes.login} onClick={this.onClick}>{this.props.children}</Link>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/components/logout.js
 **/